import { Injectable } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable, of, throwError, catchError } from 'rxjs';

import { NotificationType, NotificationService } from '@core';
import { CookieboxService } from '../cookiebox.service';

@Injectable({
    providedIn: 'root',
})
export class CookieboxMultiplePrivacyStatementResolver {
    public constructor(
        private readonly cookieboxService: CookieboxService,
        private readonly router: Router,
        private readonly notificationService: NotificationService,
    ) {}
    public resolve(
        route: ActivatedRouteSnapshot,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        state: RouterStateSnapshot,
    ): Observable<Record<string, SafeHtml> | UrlTree> {
        const privacyStatementUrls = route.data.privacyStatementUrls as Record<string, string>;

        if (!privacyStatementUrls) {
            return throwError(
                () => new Error('CookieboxMultiplePrivacyStatementResolver: Missing privacy statement url'),
            );
        }

        return this.cookieboxService.fetchMultiple(privacyStatementUrls).pipe(
            catchError(() => {
                this.notificationService.notify(
                    'Datenschutzerklärung konnte nicht geladen werden.',
                    NotificationType.CRITICAL,
                );
                return of(this.router.createUrlTree(['/']));
            }),
        );
    }
}
